import { Value } from 'baseui/select';
import { capitalize } from 'common/utils/string';
import { useFormState } from 'components/elements/form';
import deleteColumn from 'components/elements/table/editable-columns/delete-column';
import TableInput from 'components/elements/table/table-input';
import {
  ActionType,
  ColumnDataType,
  IColumn,
} from 'components/elements/table/type';
import useGetGuestColumn from 'hooks/use-get-guest-column';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

import { addNewDocumentPurchaseGuest } from '../../hooks/use-get-default-values';
import { DocumentPurchaseItemGuestFormType } from '../form-type';

// function preferenceTransformer(item: PreferenceTagItemModel): Option {
//   return {
//     id: item.id,
//     label: item.name,
//     preferenceId: item.id,
//   };
// }

function useGetVisaTableList(): IColumn<DocumentPurchaseItemGuestFormType>[] {
  const { t } = useTranslation();
  const { editable } = useFormState();

  const guestColumn = useGetGuestColumn();

  // const selectProps = {
  //   dataType: ColumnDataType.selectMulti,
  //   useListQueryHook: useGetPreferenceGroups,
  //   listKeyFunction: getPreferenceGroupsKey,
  //   getMemoizedListVariables: React.useCallback(
  //     (page, q) => ({
  //       params: {
  //         q,
  //         page,
  //         type: 'booking',
  //         sub_type: PreferenceGroupSubTypeEnum.Visa,
  //       },
  //     }),
  //     [],
  //   ),
  //   listTransformer(result) {
  //     return result.data.map((v) => preferenceTransformer(v));
  //   },
  //   paginationTransformer(result) {
  //     return result.meta;
  //   },
  // };
  return [
    {
      header: t('common:guest'),
      accessorKey: 'guestId',
      minSize: 250,
      dataType: ColumnDataType.select,
      required: true,
      selectProps: guestColumn,
    },
    ...deleteColumn(editable),
  ];
}

const VisaTable = (props: { parentIndex: number }) => {
  const { editable } = useFormState();
  const name =
    `documentPurchases.${props.parentIndex}.documentPurchaseGuests` as const;
  const { clearErrors, control, setValue, getValues, trigger } =
    useFormContext();

  const fields = useWatch({
    control,
    name,
  });

  const { update, remove } = useFieldArray({
    control,
    name,
  });

  const columns = useGetVisaTableList();

  const dispatch = React.useCallback(
    (action) => {
      const guests = getValues(name);
      const currentActionRow = action.rowIndex as number;
      const guest = guests[
        currentActionRow
      ] as DocumentPurchaseItemGuestFormType;

      const type = action.type as ActionType;
      const columnId =
        action.columnId as keyof DocumentPurchaseItemGuestFormType;
      const value = action.value;
      const extra = action.extra as Value;

      const otherVal: () => Partial<DocumentPurchaseItemGuestFormType> = () => {
        if (columnId === 'guestId') {
          return {
            guestName: extra?.[0]
              ? `${capitalize(extra?.[0]?.extra?.title)} ${
                  extra?.[0].extra.name
                }`
              : '',
          };
        }
        return {};
      };

      if (type === 'addRow') {
        const addRow: DocumentPurchaseItemGuestFormType[] = [
          ...guests,
          {
            ...addNewDocumentPurchaseGuest(),
          },
        ];
        setValue(name, addRow);
        trigger(name);
      } else if (type === 'removeRow') {
        remove(currentActionRow);
        trigger(name);
      } else if (type === 'update_cell') {
        const _value = {
          ...guest,
          [columnId]: value,
          ...otherVal(),
        };
        update(currentActionRow, _value);
        clearErrors(name);
      }
    },
    [clearErrors, getValues, name, remove, setValue, trigger, update],
  );

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns}
        data={fields}
        dispatch={dispatch}
        disabled={!editable}
        name={name}
        uniqueRowKey="customId"
      />
    </div>
  );
};

export default VisaTable;
